import { render, staticRenderFns } from "./AppStoreRedirectCard.vue?vue&type=template&id=6a24ef46"
import script from "./AppStoreRedirectCard.vue?vue&type=script&lang=js"
export * from "./AppStoreRedirectCard.vue?vue&type=script&lang=js"
import style0 from "./AppStoreRedirectCard.vue?vue&type=style&index=0&id=6a24ef46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports